// // src/components/cart/OrderCartPage.tsx
// import React, { useEffect, useMemo, useState } from "react";
// import { toast } from "react-toastify";
// import { useCart } from "components/CartContext";
// import { fetchSpecialFees, pickEligibleSpecialFee, mapSpecialFeeToUiFee, type SpecialFee, type UiFee } from "components/specialFeeTaxCloud";
// import SpecialFeePicker, { type SpecialFeePickerV2Handle } from "components/Tax/SpecialFeeui";
// import { getImageSrc, useVariantImageUrlMap } from "components/Tableimageshelpers";
// import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
// // if you already have a CartItem type, keep it; otherwise:
// type CartItem = {
//     product_id: string;
//     variant_id: string;
//     name: string;
//     image_url?: string;
//     quantity: number;
//     unit_retail_price: number;
//     tax_details?: { tax_rate?: number };
// };
// type FeePayload = {
//     specialfee?: any[] | null;
//     selected_fee_ids?: string[];
//     total_amount?: number;
//     total_tax_amount?: number;
//     total_tax_percentage?: number;
// };

// type Base = "agent" | "realtor" | "teammember";
// type Props = { base: Base };

// const OrderCartPage: React.FC<Props> = ({ base }) => {
//     console.log("Rendering OrderCartPage");
//     const cartId = localStorage.getItem("cart_id");
//     const userId = getAuthCookie("userId");
//     const signageId = localStorage.getItem("supplierId");
//     const token = getAuthCookie("sessionToken");
//     const { fetchCart } = useCart();
//     const navigate = useNavigate();
//     const [loading, setLoading] = useState(true);
//     const [applying, setApplying] = useState(false);
//     const [showCoupon, setShowCoupon] = useState(false);
//     const [removingKey, setRemovingKey] = useState<string | null>(null);
//     const [items, setItems] = useState<CartItem[]>([]);
//     const [cartData, setCartData] = useState<any>(null);
//     const [discountPct, setDiscountPct] = useState<number>(0);
//     const [coupon, setCoupon] = useState<string>("");
//     const [effectiveMap, setEffectiveMap] = useState<Record<string, number>>({});
//     const [productImages, setProductImages] = useState<any[]>([]);
//     const feeRef = React.useRef<SpecialFeePickerV2Handle>(null);
//     const [feePayload, setFeePayload] = React.useState<FeePayload | null>(null);
//     const keyFor = (it: { product_id: string; variant_id: string }) =>
//         `${it.product_id}:${it.variant_id}`;
//     // stable handler (no hooks inside JSX)
//     const handleFeePayloadChange = React.useCallback((p: FeePayload) => {
//         setFeePayload(prev => {
//             const prevKey = JSON.stringify({
//                 rows: (prev?.specialfee ?? []).map(f => [f.specialfee_id, f.specialfee_amount, f.specialfee_tax_amount]),
//                 ids: prev?.selected_fee_ids,
//             });
//             const nextKey = JSON.stringify({
//                 rows: (p?.specialfee ?? []).map(f => [f.specialfee_id, f.specialfee_amount, f.specialfee_tax_amount]),
//                 ids: p?.selected_fee_ids,
//             });
//             return prevKey === nextKey ? prev : p;
//         });
//     }, []);

//     const fetchEffectivePrice = async (it: any, qty: number) => {
//         try {
//             const url = `${process.env.REACT_APP_API_URL}/signage/${signageId}/products/${it.product_id}/variants/${it.variant_id}/resolve-assignment-discount`;
//             const res = await fetch(url, {
//                 method: "POST",
//                 headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
//                 body: JSON.stringify({ quantity: qty }),
//             });
//             if (!res.ok) throw new Error("discount fetch failed");
//             const data = await res.json();
//             const ep = Number(data?.effective_price ?? it.unit_retail_price ?? 0);
//             console.log("effective price", ep);
//             setEffectiveMap(m => ({ ...m, [keyFor(it)]: ep }));
//         } catch {
//             // fallback to base price if API fails
//             setEffectiveMap(m => ({ ...m, [keyFor(it)]: Number(it.unit_retail_price || 0) }));
//         }
//     };

//     useEffect(() => {
//         (items || []).forEach(it => {
//             fetchEffectivePrice(it, Number(it.quantity || 1));
//         });
//     }, [items]); // whenever items (or their quantities) change




//     // fetch cart
//     useEffect(() => {
//         const run = async () => {
//             if (!cartId || !token) return;
//             try {
//                 setLoading(true);
//                 const res = await fetch(`${process.env.REACT_APP_API_URL}/carts/${cartId}`, {
//                     headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
//                 });
//                 const data = await res.json();
//                 setCartData(data);
//                 setItems(data?.cart_items || []);
//                 const firstItem = Array.isArray(data?.cart_items) ? data.cart_items[0] : undefined;

//                 const productImages =
//                     firstItem?.images?.length
//                         // put the default image first, then the rest
//                         ? [
//                             ...firstItem.images.filter((img: any) => img?.default).map((img: any) => img.url),
//                             ...firstItem.images.filter((img: any) => img?.default).map((img: any) => (img: any) => img.url),
//                         ]
//                         : (firstItem?.image_url ? [firstItem.image_url] : []);

//                 // If your state expects an array of URLs:
//                 setProductImages(productImages);
//             } catch {
//                 toast.error("Failed to load cart");
//             } finally {
//                 setLoading(false);
//             }
//         };
//         run();
//     }, [cartId, token]);

//     // mutations
//     const updateQuantity = async (cartItem: CartItem, newQty: number) => {
//         if (newQty < 1 || !token || !cartId) return;
//         try {
//             const res = await fetch(`${process.env.REACT_APP_API_URL}/carts/${cartId}`, {
//                 method: "PATCH",
//                 headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
//                 body: JSON.stringify({ ...cartItem, quantity: newQty }),
//             });
//             if (!res.ok) throw new Error();
//             setItems(prev =>
//                 prev.map(it =>
//                     it.product_id === cartItem.product_id && it.variant_id === cartItem.variant_id
//                         ? { ...it, quantity: newQty }
//                         : it
//                 )
//             );
//             // refresh effective price for that item/qty
//             fetchEffectivePrice(cartItem, newQty);

//             toast.success("Cart updated");

//             // if (!res.ok) throw new Error();
//             // setItems(prev =>
//             //     prev.map(it =>
//             //         it.product_id === cartItem.product_id && it.variant_id === cartItem.variant_id
//             //             ? { ...it, quantity: newQty }
//             //             : it
//             //     )
//             // );
//             // toast.success("Cart updated");
//         } catch {
//             toast.error("Failed to update quantity");
//         }
//     };

//     const removeItem = async (productId: string, variantId: string) => {
//         if (!token || !cartId) return;
//         const key = `${productId}:${variantId}`;
//         setRemovingKey(key);
//         try {
//             const res = await fetch(
//                 `${process.env.REACT_APP_API_URL}/carts/${cartId}/products/${productId}/variants/${variantId}`,
//                 { method: "DELETE", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
//             );
//             if (!res.ok) throw new Error();
//             setItems(prev => prev.filter(i => !(i.product_id === productId && i.variant_id === variantId)));
//             fetchCart(); // sync header badge
//             toast.success("Removed from cart");
//         } catch {
//             toast.error("Failed to remove item");
//         } finally {
//             setRemovingKey(null);
//         }
//     };

//     // totals
//     // const subTotal = useMemo(
//     //     () => items.reduce((t, i) => t + Number(i.quantity || 0) * Number(i.unit_retail_price || 0), 0),
//     //     [items]
//     // );
//     // const tax = useMemo(
//     //     () =>
//     //         items.reduce((acc, i) => {
//     //             const rate = Number(i.tax_details?.tax_rate || 0);
//     //             return acc + (Number(i.quantity || 0) * Number(i.unit_retail_price || 0) * rate) / 100;
//     //         }, 0),
//     //     [items]
//     // );

//     const subTotal = useMemo(
//         () =>
//             items.reduce((t, i) => {
//                 const k = keyFor(i);
//                 const each = effectiveMap[k] ?? Number(i.unit_retail_price || 0);
//                 return t + each * Number(i.quantity || 0);
//             }, 0),
//         [items, effectiveMap]
//     );

//     const tax = useMemo(
//         () =>
//             items.reduce((acc, i) => {
//                 const k = keyFor(i);
//                 const each = effectiveMap[k] ?? Number(i.unit_retail_price || 0);
//                 const base = each * Number(i.quantity || 0);
//                 const rate = Number(i.tax_details?.tax_rate || 0);
//                 return acc + (base * rate) / 100;
//             }, 0),
//         [items, effectiveMap]
//     );

//     const discountAmt = (subTotal * discountPct) / 100;
//     const total = Math.max(0, subTotal - discountAmt + tax);

//     const suppliersHref = `/${base}/suppliers`;
//     const checkoutHref = `/${base}/order/checkout`;

//     const applyCoupon = async (e: React.FormEvent) => {
//         e.preventDefault();
//         // simple client-side demo logic; replace with backend call when ready
//         try {
//             setApplying(true);
//             if (!coupon.trim()) {
//                 setDiscountPct(0);
//                 toast.info("Coupon cleared");
//             } else if (coupon.trim().toUpperCase() === "SAVE15") {
//                 setDiscountPct(15);
//                 toast.success("15% discount applied");
//             } else {
//                 setDiscountPct(0);
//                 toast.error("Invalid coupon");
//             }
//             setShowCoupon(false);
//         } finally {
//             setApplying(false);
//         }
//     };

//     const onProceedToCheckout = async () => {
//         const feeRows = feePayload?.specialfee ?? [];

//         // (optional) ensure numeric fields are numbers for Go float64
//         const normalizeFee = (f: any) => ({
//             specialfee_id: String(f.specialfee_id ?? ""),
//             specialfee_name: String(f.specialfee_name ?? ""),
//             specialfee_amount: Number(f.specialfee_amount || 0),
//             specialfee_tax_percentage: Number(f.specialfee_tax_percentage || 0),
//             specialfee_tax_amount: Number(f.specialfee_tax_amount || 0),
//             specialfee_taxable: f?.specialfee_taxable !== false,
//         });

//         const body = {
//             // ... your existing fields here ...
//             order_charges: [{
//                 specialfee: feeRows.map(normalizeFee), // ✅ selected fees + tax
//             }],
//             // if your backend also stores the raw selection ids, pass them too:
//             selected_fee_ids: feePayload?.selected_fee_ids ?? [],
//         };

//         await fetch(`${process.env.REACT_APP_API_URL}/carts/${cartId}`, {
//             method: "PATCH",
//             headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//             body: JSON.stringify(body),
//         });

//         // then navigate to checkout page (unchanged)
//         navigate(checkoutHref);
//     };

//     const initialFeeIds = React.useMemo<string[] | undefined>(() => {
//         // Prefer cart’s saved rows (if any)
//         const rows = cartData?.order_charges?.[0]?.specialfee ?? [];
//         const ids = Array.isArray(rows) ? rows.map((r: any) => String(r?.specialfee_id)).filter(Boolean) : [];
//         return ids.length ? ids : undefined;
//     }, [cartData]);

//     const feesAmount = Number(feePayload?.total_amount || 0);
//     const feesTax = Number(feePayload?.total_tax_amount || 0);
//     // Keep your existing subTotal/discount/tax, then:
//     const totalWithFees = Math.max(0, subTotal - discountAmt + tax + feesAmount + feesTax);
// const idOf = (x?: any): string => (typeof x === "string" ? x : (x?.url ?? "")) || "";
// const buildImageUrl = (raw?: string) => {
//     if (!raw) return "";
//     if (/^https?:\/\//i.test(raw)) return raw;
//     const base = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
//     const path = String(raw).replace(/\\/g, "/").replace(/^\/+/, "");
//     return `${base}/${encodeURI(path)}`;
// };
// const productImageIds = React.useMemo(
//     () => (productImages || []).map((img: any) => idOf(img)).filter(Boolean),
//     [productImages]
// );

// const dataForMap = React.useMemo(() => {
//     if (!productImageIds.length) return [];
//     return [{ product: { variants: [{ images: productImageIds.map((url) => ({ url })) }] } }];
// }, [productImageIds]);

// const imageUrlMap = useVariantImageUrlMap(dataForMap, token);

// // 🔧 bump when map content changes (even if the object ref is stable)
// const mapVersion = React.useMemo(
//     () => (imageUrlMap ? Object.keys(imageUrlMap).length : 0),
//     [imageUrlMap]
// );

//     // ✅ will re-run when productImages change OR when map gets populated
// const resolvedImages = React.useMemo(
//     () =>
//         (productImages || []).map((img: any) => {
//             const id = idOf(img);
//             return {
//                 src: getImageSrc(id, imageUrlMap) || buildImageUrl(id),
//                 alt: img?.alt_text || "",
//             };
//         }),
//     [productImages, mapVersion]   // <-- changed here
// );


//     console.log(resolvedImages, "rsgfff")

//     return (
//         <div className="content">
//             {/* top back link */}
//             <div className="d-flex align-items-center gap-2 mb-3">
//                 <Link to={suppliersHref} className="text-decoration-none fw-bold text-muted">
//                     <i className="ri-arrow-left-line me-1"></i> Continue Shopping
//                 </Link>
//             </div>

//             {/* title row with icon */}
//             <div className="d-flex align-items-center gap-2 mb-1">
//                 <i className="ri-shopping-bag-3-line fs-3" style={{ color: "#2563eb" }}></i>
//                 <h3 className="mb-0">Shopping Cart</h3>
//             </div>
//             <div className="text-muted mb-4 fs-14">{items.length} {items.length === 1 ? "item" : "items"} in your cart</div>

//             <div className="row g-4">
//                 {/* Left: items */}
//                 <div className="col-12 col-lg-6">
//                     {loading ? (
//                         <div className="card"><div className="card-body"><div className="placeholder-glow">
//                             <span className="placeholder col-12 mb-3"></span>
//                             <span className="placeholder col-10 mb-3"></span>
//                             <span className="placeholder col-11"></span>
//                         </div></div></div>
//                     ) : !items.length ? (
//                         <div className="text-center p-5 border rounded-3">
//                             <div className="display-6 mb-2">🛒</div>
//                             <h5 className="mb-2">Your cart is empty</h5>
//                             <Link to={suppliersHref} className="btn btn-primary">Shop Now</Link>
//                         </div>
//                     ) : (
//                         items.map((it) => {
//                             const key = `${it.product_id}:${it.variant_id}`;
//                             const img = it.image_url ? `${process.env.REACT_APP_BASE_URL}${it.image_url}` : "assets/images/products/default-img.png";
//                             // const each = Number(it.unit_retail_price || 0);
//                             // const line = each * Number(it.quantity || 0);
//                             const each = effectiveMap[key] ?? Number(it.unit_retail_price || 0);
//                             const line = each * Number(it.quantity || 0);


//                             return (
//                                 <div key={key} className="card border-0 shadow-lg mb-4 br-8">
//                                     <div className="card-body p-4">
//                                         <div className="row g-3 align-items-start">
//                                             {/* Image — fixed size on all screens */}
// <div className="col-auto mb-2 mb-lg-0">
//     <div className="rounded-3 overflow-hidden border" style={{ width: 72, height: 72 }}>
//         {resolvedImages?.[0] ? (
//             <img
//                 src={resolvedImages[0].src}
//                 alt={resolvedImages[0].alt || "Product image"}
//                 className="w-100 h-100"
//                 style={{ objectFit: "cover" }}
//             />
//         ) : (
//             <div className="w-100 h-100 d-flex align-items-center justify-content-center text-muted small">
//                 No image
//             </div>
//         )}
//     </div>
// </div>


//                                             {/* Title + meta */}
//                                             <div className="col d-flex justify-content-between">
//                                                 <div>

//                                                     <h6 className="fs-15">{it.name}</h6>
//                                                     <div className="text-muted">${each.toFixed(2)} each</div>
//                                                 </div>
//                                                 <button
//                                                     className="btn btn-sm btn-link text-secondary p-0 d-lg-none btn-ghost-danger"
//                                                     onClick={() => removeItem(it.product_id, it.variant_id)}
//                                                     aria-label="Remove"
//                                                     title="Remove"
//                                                     disabled={removingKey === key}
//                                                 >
//                                                     {removingKey === key ? (
//                                                         <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                                                     ) : (
//                                                         <i className="ri-close-line fs-5"></i>
//                                                     )}
//                                                 </button>
//                                             </div>

//                                             {/* RIGHT SIDE (md and up): Qty + Subtotal + Remove */}
//                                             <div className="d-none d-lg-flex col-md-6 col-lg-5 ms-md-auto align-items-center justify-content-end gap-4">
//                                                 {/* Qty (single-border stepper) */}
//                                                 <div className="text-center">
//                                                     <div className="fs-13 fw-medium mb-1 small">Quantity</div>
//                                                     <div className="align-items-center border border-2 br-8 d-inline-flex overflow-hidden">
//                                                         <button
//                                                             className="border-0 btn btn-sm fs-16 fw-bold px-3"
//                                                             onClick={() => updateQuantity(it, (it.quantity || 1) - 1)}
//                                                             aria-label="Decrease quantity"
//                                                         >
//                                                             −
//                                                         </button>
//                                                         <input
//                                                             type="number"
//                                                             className="border-0 form-control form-control-sm fs-12 fw-medium text-center"
//                                                             min={1}
//                                                             value={it.quantity}
//                                                             onChange={(e) =>
//                                                                 updateQuantity(it, Math.max(1, parseInt(e.target.value || "1", 10)))
//                                                             }
//                                                             style={{ width: 56 }}
//                                                         />
//                                                         <button
//                                                             className="btn btn-sm px-3 border-0 fs-16 fw-bold"
//                                                             onClick={() => updateQuantity(it, (it.quantity || 1) + 1)}
//                                                             aria-label="Increase quantity"
//                                                         >
//                                                             +
//                                                         </button>
//                                                     </div>
//                                                 </div>

//                                                 {/* Subtotal */}
//                                                 <div className="text-end">
//                                                     <div className="fs-13 fw-medium small">Subtotal</div>
//                                                     <div className="fw-semibold fs-6">${line.toFixed(2)}</div>
//                                                 </div>

//                                                 {/* Remove with subtle divider */}
//                                                 <div className="ps-3">
//                                                     <button
//                                                         className="btn btn-sm btn-link text-secondary p-0 btn-ghost-danger"
//                                                         onClick={() => removeItem(it.product_id, it.variant_id)}
//                                                         aria-label="Remove"
//                                                         title="Remove"
//                                                         disabled={removingKey === key}
//                                                     >
//                                                         {removingKey === key ? (
//                                                             <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                                                         ) : (
//                                                             <i className="ri-close-line fs-5"></i>
//                                                         )}
//                                                     </button>
//                                                 </div>
//                                             </div>

//                                             {/* BOTTOM BAR (xs/sm): Qty + Subtotal + Remove under the image/title) */}
//                                             <div className="col-12 d-flex d-lg-none align-items-center justify-content-between pt-2 mt-1 border-top">
//                                                 {/* Qty */}
//                                                 <div className="align-items-center align-items-start d-flex gap-2">
//                                                     <div className="fs-12 mb-1 small text-muted">Qty:</div>
//                                                     <div className="align-items-center border border-2 br-8 d-inline-flex overflow-hidden">
//                                                         <button
//                                                             className="btn btn-sm px-3 border-0"
//                                                             onClick={() => updateQuantity(it, (it.quantity || 1) - 1)}
//                                                             aria-label="Decrease quantity"
//                                                         >
//                                                             −
//                                                         </button>
//                                                         <input
//                                                             type="number"
//                                                             className="form-control form-control-sm text-center border-0"
//                                                             min={1}
//                                                             value={it.quantity}
//                                                             onChange={(e) =>
//                                                                 updateQuantity(it, Math.max(1, parseInt(e.target.value || "1", 10)))
//                                                             }
//                                                             style={{ width: 56 }}
//                                                         />
//                                                         <button
//                                                             className="btn btn-sm px-3 border-0"
//                                                             onClick={() => updateQuantity(it, (it.quantity || 1) + 1)}
//                                                             aria-label="Increase quantity"
//                                                         >
//                                                             +
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                                 {/* Subtotal */}
//                                                 <div className="text-center">
//                                                     <div className="text-muted small mb-1">Subtotal</div>
//                                                     <div className="fw-semibold">${line.toFixed(2)}</div>
//                                                 </div>

//                                                 {/* Remove with light divider */}
//                                                 {/* <div className="ps-3">
//                                                     <button
//                                                         className="btn btn-sm btn-link text-secondary p-0"
//                                                         onClick={() => removeItem(it.product_id, it.variant_id)}
//                                                         aria-label="Remove"
//                                                         title="Remove"
//                                                         disabled={removingKey === key}
//                                                     >
//                                                         {removingKey === key ? (
//                                                             <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
//                                                         ) : (
//                                                             <i className="ri-close-line fs-5"></i>
//                                                         )}
//                                                     </button>
//                                                 </div> */}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             );
//                         })
//                     )}
//                 </div>

//                 {/* Right: summary */}
//                 <div className="col-12 col-lg-4">
//                     <div className="card border-0 shadow-lg br-8 position-sticky" style={{ top: 16 }}>
//                         <div className="card-body">
//                             <div className="d-flex align-items-center gap-2 mb-3">
//                                 <i className="ri-bank-card-line fs-20" style={{ color: "#2563eb" }}></i>
//                                 <p className="fs-16 mb-0">Order Summary</p>
//                             </div>

//                             <ul className="list-unstyled mb-3 small">
//                                 <li className="d-flex justify-content-between mb-2">
//                                     <span className="fs-13">Subtotal:</span>
//                                     <span className="fs-14 fw-medium">${subTotal.toFixed(2)}</span>
//                                 </li>
//                                 <li className="d-flex justify-content-between mb-2">
//                                     <span className="fs-13"><i className="ri-truck-line me-1"></i> Shipping:</span>
//                                     <span className="fs-14 fw-medium">Free</span>
//                                 </li>
//                                 <li className="d-flex justify-content-between mb-2">
//                                     <span className="text-success fs-13"><i className="ri-percent-line me-1"></i> Discount ({discountPct || 0}%):</span>
//                                     <span className="text-success fs-14 fw-medium">-${discountAmt.toFixed(2)}</span>
//                                 </li>

//                                 <li className="d-flex justify-content-between mb-2">
//                                     <span className="fs-13">Tax :</span> <span className="fs-14 fw-medium">---</span>
//                                 </li>
//                             </ul>

//                             <hr className="my-3" />

//                             {/* coupon UX — collapsed button -> expand input + apply + cancel */}
//                             {!showCoupon ? (
//                                 <button
//                                     type="button"
//                                     className="align-items-center br-8 btn btn-cancel d-flex fw-medium justify-content-center mb-3 w-100"
//                                     onClick={() => setShowCoupon(true)}
//                                 >
//                                     <i className="ri-price-tag-3-line me-2"></i> Apply Discount Code
//                                 </button>
//                             ) : (
//                                 <form onSubmit={applyCoupon} className="mb-3">
//                                     <div className="d-flex gap-2 justify-content-center">
//                                         <div className="input-group w-75">
//                                             <input
//                                                 className="form-control"
//                                                 placeholder="Enter discount code"
//                                                 value={coupon}
//                                                 onChange={(e) => setCoupon(e.target.value)}
//                                             />
//                                         </div>
//                                         <button className="btn btn-primary" disabled={applying}>
//                                             {applying ? "Applying..." : "Apply"}
//                                         </button>
//                                     </div>
//                                     <button
//                                         type="button"
//                                         className="btn btn-ghost-dark btn-link mt-2 w-100"
//                                         onClick={() => { setShowCoupon(false); setCoupon(""); }}
//                                     >
//                                         Cancel
//                                     </button>
//                                 </form>
//                             )}
//                             <div className="">
//                                 <SpecialFeePicker
//                                     ref={feeRef}
//                                     token={token || ""}
//                                     personId={userId || ""}           // createdBy / owner id
//                                     shippingAddress={null}            // or pass a real address if you have it
//                                     knownTaxType="manual"
//                                     isTaxable
//                                     statusOk
//                                     initialSelectedIds={initialFeeIds}  // ✅ preselect from cartData
//                                     onPayloadChange={handleFeePayloadChange}
//                                 />
//                                 <div className="d-flex justify-content-between mt-2 text-muted small">
//                                     <span>Selected Fees:</span>
//                                     <span>
//                                         ${Number(feePayload?.total_amount || 0).toFixed(2)}
//                                         {Number(feePayload?.total_tax_amount || 0) > 0 && (
//                                             <> (+${Number(feePayload?.total_tax_amount || 0).toFixed(2)} tax)</>
//                                         )}
//                                     </span>
//                                 </div>
//                             </div>
//                             <hr className="my-3" />

//                             <div className="d-flex justify-content-between align-items-center mb-3">
//                                 <h6 className="mb-0">Total:</h6>
//                                 <h5 className="mb-0">${totalWithFees.toFixed(2)}</h5>                            </div>


//                             {/* 
//                             <Link to={checkoutHref} className="btn btn-primary table-addbutton w-100">
//                                 <i className="ri-bank-card-line me-2"></i> Proceed to Checkout
//                             </Link> */}
//                             <button type="button" className="btn btn-primary table-addbutton w-100" onClick={onProceedToCheckout}>
//                                 <i className="ri-bank-card-line me-2"></i> Proceed to Checkout
//                             </button>


//                             <div className="text-center text-muted small mt-2">
//                                 Secure checkout with SSL encryption
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default OrderCartPage;






// src/components/cart/OrderCartPage.tsx
import React, { useEffect, useMemo, useState, useCallback, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useCart } from "components/CartContext";
import { getImageSrc, useVariantImageUrlMap } from "components/Tableimageshelpers";
import "../../assets/css/SignageOrders.css";
import SpecialFeePicker, { type SpecialFeePickerV2Handle } from "components/Tax/SpecialFeeui";
import BrokerageAndAgentCouponDiscount, { type Discount } from "components/Tax/RealtorandAgentCouponDiscount"
import { useCouponExpirationCheck } from "components/Tax/CouponExpirationCheck";
import { DiscountAmountDisplay, getAgentRealtorCheckoutLinePricing } from "components/DiscountLabelBadge";

import { getAuthCookie } from "../../utils/authCookies";
import imagecustomRounded from "assets/images/imagecustomrounded.png";

type CartItem = {
    product_id: string;
    variant_id: string;
    name: string;
    image_url?: string;
    images?: Array<{ url: string; default?: boolean }>;
    design_id?: string;
    design_name?: string;
    preview_url?: string;
    quantity: number;
    unit_retail_price: number;
    changed_unit_price?: number;
    discount_on_total_quantity?: number;
    discount_on_unit_quantity?: number;
    tax_details?: { tax_rate?: number };
    customizations?: { fields?: Array<{ field_name: string; field_type?: string; value?: string }> };
};

type FeePayload = {
    specialfee?: any[] | null;
    selected_fee_ids?: string[];
    total_amount?: number;
    total_tax_amount?: number;
    total_tax_percentage?: number;
};

type Base = "agent" | "realtor" | "teammember";
type Props = { base: Base };

const OrderCartPage: React.FC<Props> = ({ base }) => {
    // ---- ids / auth / router ----
    const cartId = localStorage.getItem("cart_id");
    const userId = getAuthCookie("userId") || "";
    const supplierId = localStorage.getItem("supplierId") || "";
    const token = getAuthCookie("sessionToken") || "";
    const navigate = useNavigate();

    // ---- context ----
    const { fetchCart } = useCart();

    // ---- state ----
    const [loading, setLoading] = useState(true);
    const [applying, setApplying] = useState(false);
    const [showCoupon, setShowCoupon] = useState(false);
    const [removingKey, setRemovingKey] = useState<string | null>(null);

    const [items, setItems] = useState<CartItem[]>([]);
    const [cartData, setCartData] = useState<any>(null);
    const location = useLocation();
    const isTeammember = location.pathname.includes('/teammember');
    const isAgent = location.pathname.includes('/agent');
    const baseRoute = isTeammember ? '/teammember' : isAgent ? '/agent' : '/realtor';

    // “assignment discount” effective unit price per item (if your API gives it)
    const [effectiveMap, setEffectiveMap] = useState<Record<string, number>>({});

    // Special Fee picker
    const feeRef = useRef<SpecialFeePickerV2Handle>(null);
    const [feePayload, setFeePayload] = useState<FeePayload | null>(null);

    // CouponDiscount state
    const [couponInput, setCouponInput] = useState<string>("");
    const [couponDiscounts, setCouponDiscounts] = useState<Discount[]>([]);
    const [perItemCouponMap, setPerItemCouponMap] = useState<Record<string, number>>({});

    // Shipping/Tax for header summary (if you compute elsewhere, wire here)
    const [shippingAmount, setShippingAmount] = useState(0);
    const [shippingTaxAmount, setShippingTaxAmount] = useState(0);
    const [specialFeeAmount, setSpecialFeeAmount] = useState(0);
    const [specialFeeTaxAmount, setSpecialFeeTaxAmount] = useState(0);
    const [productImages, setProductImages] = useState<any[]>([]);
    // ---- helpers ----
    const num = (v: any) => Number(v || 0);
    const round2 = (n: number) => Math.round(num(n) * 100) / 100;
    const money = (v: any) => num(v).toFixed(2);
    const showTBD = (val: number) => (removingKey || items.length === 0 ? "TBD" : (val > 0 ? `$${money(val)}` : "TBD"));
    const keyFor = (p: { product_id?: string; variant_id?: string }) =>
        `${String(p.product_id ?? "")}:${String(p.variant_id ?? "")}`;

    // ---- Resolve “assignment discount” effective unit price per item/qty ----
    const fetchEffectivePrice = useCallback(
        async (it: CartItem, qty: number) => {
            try {
                const url = `${process.env.REACT_APP_API_URL}/signage/${supplierId}/products/${it.product_id}/variants/${it.variant_id}/resolve-assignment-discount`;
                const res = await fetch(url, {
                    method: "POST",
                    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                    body: JSON.stringify({ quantity: qty }),
                });
                if (!res.ok) throw new Error("discount fetch failed");
                const data = await res.json();
                // Handle both "effective_price" and "effective_price   " (with trailing spaces)
                const effectivePrice = data?.effective_price ?? data?.["effective_price   "] ?? it.unit_retail_price ?? 0;
                const ep = Number(effectivePrice);
                setEffectiveMap((m) => ({ ...m, [keyFor(it)]: ep }));
            } catch {
                setEffectiveMap((m) => ({ ...m, [keyFor(it)]: Number(it.unit_retail_price || 0) }));
            }
        },
        [supplierId, token]
    );

    // refresh effective unit when items/qty change
    useEffect(() => {
        (items || []).forEach((it) => fetchEffectivePrice(it, Number(it.quantity || 1)));
    }, [items, fetchEffectivePrice]);

    // ---- load cart ----
    useEffect(() => {
        const run = async () => {
            if (!cartId || !token) return;
            try {
                setLoading(true);
                const res = await fetch(`${process.env.REACT_APP_API_URL}/carts/${cartId}`, {
                    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                });
                const data = await res.json();
                setCartData(data);
                setItems(data?.cart_items || []);
                // after: setCartData(data); setItems(data?.cart_items || []);
                try {
                    const persistedCouponMap: Record<string, number> = {};
                    const persistedEffective: Record<string, number> = {};

                    (data?.cart_items || []).forEach((it: any) => {
                        const k = `${it.product_id}:${it.variant_id}`;
                        const qty = Number(it.quantity || 0);
                        const unitBefore = Number(it.unit_retail_price || 0);
                        const rowDisc = Number(it.discount_on_total_quantity || 0);
                        const changedEach = Number(it.changed_unit_price || 0);

                        // discount map (what rowMath() uses)
                        if (!isNaN(rowDisc) && rowDisc > 0) {
                            persistedCouponMap[k] = Math.round(rowDisc * 100) / 100;
                        }

                        // effective (pre-discount) unit price used by rowMath()
                        // prefer the server’s unit_retail_price; derive if missing
                        if (unitBefore > 0) {
                            persistedEffective[k] = unitBefore;
                        } else if (changedEach > 0 && qty > 0) {
                            // reverse from saved: lineAfter = changedEach*qty, lineBase = lineAfter + rowDisc
                            const lineAfter = changedEach * qty;
                            const lineBase = lineAfter + rowDisc;
                            persistedEffective[k] = Math.round((lineBase / qty) * 100) / 100;
                        }
                    });

                    // 🔑 hydrate maps from server so UI shows saved numbers
                    setPerItemCouponMap(prev => ({ ...prev, ...persistedCouponMap }));
                    setEffectiveMap(prev => ({ ...prev, ...persistedEffective }));
                } catch { }

                const firstItem = Array.isArray(data?.cart_items) ? data.cart_items[0] : undefined;

                const productImages =
                    firstItem?.images?.length
                        // put the default image first, then the rest
                        ? [
                            ...firstItem.images.filter((img: any) => img?.default).map((img: any) => img.url),
                            ...firstItem.images.filter((img: any) => img?.default).map((img: any) => (img: any) => img.url),
                        ]
                        : (firstItem?.image_url ? [firstItem.image_url] : []);

                // If your state expects an array of URLs:
                setProductImages(productImages);
            } catch {
                toast.error("Failed to load cart");
            } finally {
                setLoading(false);
            }
        };
        run();
    }, [cartId, token]);

    // ---- image utils (keep simple) ----
    const idOf = (x?: any): string => (typeof x === "string" ? x : (x?.url ?? "")) || "";
    const hasCustomDesign = (it?: CartItem) =>
        Boolean(String(it?.design_id || "").trim() && String(it?.design_name || "").trim());
    const buildImageUrl = (raw?: string) => {
        if (!raw) return "";
        if (/^https?:\/\//i.test(raw)) return raw;
        const base = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
        const path = String(raw).replace(/\\/g, "/").replace(/^\/+/, "");
        return `${base}/${encodeURI(path)}`;
    };

    // ---- mutations ----
    const updateQuantity = async (cartItem: CartItem, newQty: number) => {
        if (newQty < 1 || !token || !cartId) return;
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/carts/${cartId}`, {
                method: "PATCH",
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
                body: JSON.stringify({ ...cartItem, quantity: newQty }),
            });
            if (!res.ok) throw new Error();
            setItems((prev) =>
                prev.map((it) =>
                    it.product_id === cartItem.product_id && it.variant_id === cartItem.variant_id
                        ? { ...it, quantity: newQty }
                        : it
                )
            );
            fetchEffectivePrice(cartItem, newQty);
            toast.success("Cart updated");
        } catch {
            toast.error("Failed to update quantity");
        }
    };

    const removeItem = async (productId: string, variantId: string) => {
        if (!token || !cartId) return;
        const key = `${productId}:${variantId}`;
        setRemovingKey(key);
        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/carts/${cartId}/products/${productId}/variants/${variantId}`,
                { method: "DELETE", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            if (!res.ok) throw new Error();

            // Update items list
            const updatedItems = items.filter((i) => !(i.product_id === productId && i.variant_id === variantId));
            setItems(updatedItems);

            // If this was the last item, delete the entire cart
            if (updatedItems.length === 0) {
                try {
                    const deleteCartRes = await fetch(
                        `${process.env.REACT_APP_API_URL}/carts/${cartId}`,
                        { method: "DELETE", headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
                    );
                    if (deleteCartRes.ok) {
                        localStorage.removeItem("cart_id");
                        toast.success("Cart cleared");
                    }
                } catch (error) {
                    console.error("Failed to delete cart:", error);
                }
            } else {
                toast.success("Removed from cart");
            }

            fetchCart(); // sync header badge
        } catch {
            toast.error("Failed to remove item");
        } finally {
            setRemovingKey(null);
        }
    };

    // ---- CouponDiscount input items ----
    const couponItems = useMemo(() => {
        return (items || []).map((ci) => {
            const k = keyFor(ci);
            const each = num(effectiveMap[k] ?? ci.unit_retail_price);
            return {
                itemId: k,
                product_id: ci.product_id,
                variant_id: ci.variant_id,
                quantity: num(ci.quantity || 0),
                unitPrice: each,
            };
        });
    }, [items, effectiveMap]);

    // ---- per-row math (uses CouponDiscount's map) ----
    // Formula: changed_unit_price = unit_retail_price - (discount_per_line / quantity)
    // This gives us: unit_price - discount = remaining_price
    const changedEachFor = (ci: CartItem): number => {
        const k = keyFor(ci);
        const each = num(effectiveMap[k] ?? ci.unit_retail_price);
        const qty = num(ci.quantity);
        const rowDisc = num(perItemCouponMap[k] ?? 0);  // Total discount for this line item
        if (qty <= 0) return each;
        const lineBase = each * qty;
        const lineAfter = Math.max(0, lineBase - rowDisc);  // Apply discount to line total
        return round2(lineAfter / qty);  // Return per-unit price after discount
    };

    const rowMath = (ci: CartItem) => {
        const k = keyFor(ci);
        const qty = num(ci.quantity);
        const eachBefore = num(effectiveMap[k] ?? ci.unit_retail_price);
        const rowDisc = num(perItemCouponMap[k] ?? 0);

        // ✅ Subtotal = quantity × original unit price (BEFORE discount)
        const itemSub = round2(eachBefore * qty);

        // ✅ After discount = subtotal - discount
        const itemAfterDiscount = round2(itemSub - rowDisc);
        const eachAfter = qty > 0 ? round2(itemAfterDiscount / qty) : eachBefore;

        // Tax calculated on discounted amount
        const rate = num(ci.tax_details?.tax_rate || 0);
        const rowTax = round2((itemAfterDiscount * rate) / 100);
        const rowTaxPct = itemAfterDiscount > 0 ? (rowTax / itemAfterDiscount) * 100 : 0;
        const lineWithTax = round2(itemAfterDiscount + rowTax);

        return { k, qty, eachBefore, eachAfter, rowDisc, itemSub, itemAfterDiscount, rowTax, rowTaxPct, lineWithTax };
    };

    // ---- totals ----
    // Subtotal = sum of (qty × unit_price) BEFORE discount
    const subTotalProducts = useMemo(
        () => (items || []).reduce((t, ci) => t + rowMath(ci).itemSub, 0),
        [items, effectiveMap]
    );
    const productTaxToShow = useMemo(
        () => (items || []).reduce((t, ci) => t + rowMath(ci).rowTax, 0),
        [items, perItemCouponMap, effectiveMap]
    );
    const totalTaxAll = useMemo(
        () => num(productTaxToShow) + num(shippingTaxAmount) + num(specialFeeTaxAmount),
        [productTaxToShow, shippingTaxAmount, specialFeeTaxAmount]
    );
    const couponAmount = useMemo(
        () => Object.values(perItemCouponMap || {}).reduce((s, n) => s + num(n), 0),
        [perItemCouponMap]
    );
    const grandTotal = useMemo(
        () => round2(subTotalProducts + num(shippingAmount) + num(specialFeeAmount) + num(totalTaxAll) - num(couponAmount)),
        [subTotalProducts, shippingAmount, specialFeeAmount, totalTaxAll, couponAmount]
    );
    const eligibilityTotal = useMemo(
        () => subTotalProducts + num(shippingAmount) + num(specialFeeAmount) + num(totalTaxAll),
        [subTotalProducts, shippingAmount, specialFeeAmount, totalTaxAll]
    );


    // ---- special fees helper ----
    const handleFeePayloadChange = useCallback((p: FeePayload) => {
        setFeePayload((prev) => {
            const prevKey = JSON.stringify({
                rows: (prev?.specialfee ?? []).map((f) => [f.specialfee_id, f.specialfee_amount, f.specialfee_tax_amount]),
                ids: prev?.selected_fee_ids,
            });
            const nextKey = JSON.stringify({
                rows: (p?.specialfee ?? []).map((f) => [f.specialfee_id, f.specialfee_amount, f.specialfee_tax_amount]),
                ids: p?.selected_fee_ids,
            });
            return prevKey === nextKey ? prev : p;
        });
        setSpecialFeeAmount(num(p?.total_amount));
        setSpecialFeeTaxAmount(num(p?.total_tax_amount));
    }, []);

    // ---- Coupon expiration check ----
    const couponProducts = useMemo(
        () => (items || []).map(it => ({
            product_id: String(it.product_id || ""),
            variant_id: String(it.variant_id || ""),
        })),
        [items]
    );

    const { checkAndProceed: checkCouponExpiration, checking: checkingCoupon, Modal: CouponExpirationModal } = useCouponExpirationCheck({
        token: token || "",
        supplierId: supplierId || "",
        customerId: userId || "",
        discountCode: (couponDiscounts[0]?.id || "").trim(),
        products: couponProducts,
        onRemoveCoupon: () => {
            // Remove expired coupon from UI state
            setCouponDiscounts([]);
            setPerItemCouponMap({});
            toast.info("Expired coupon removed. Proceeding with original prices.");
        },
    });


    const buildCartItemsPayload = () => {
        return (items || []).map((ci) => {
            const k = keyFor(ci);
            const qty = num(ci.quantity || 0);
            const eachBefore = num(ci.unit_retail_price);                   // original unit
            const rowDiscTotal = num(perItemCouponMap[k] || 0);             // split from CouponDiscount
            const changedUnit = changedEachFor(ci);                          // effective unit after discount
            const total_price = round2(eachBefore * qty);                    // pre-discount line price
            const item_sub_total = round2(changedUnit * qty);                // post-discount, pre-tax
            const discount_on_total_quantity = round2(rowDiscTotal);         // requested field name (no _amount)
            const discount_on_unit_quantity = round2(rowDiscTotal / Math.max(1, qty));

            return {
                // identifiers you already send on cart items
                product_id: ci.product_id,
                variant_id: ci.variant_id,

                // required computed fields (you asked for):
                quantity: qty,
                unit_retail_price: round2(eachBefore),
                changed_unit_price: round2(changedUnit),
                discount_on_unit_quantity,
                discount_on_total_quantity,
                total_price,
                item_sub_total,
            };
        });
    };


    // ---- Proceed to checkout (store fees & coupon details to the cart if needed) ----
    const onProceedToCheckout = async () => {
        if (!cartId || !token) return;

        // ✅ Check coupon expiration first
        await checkCouponExpiration(async () => {
            // This callback runs only if coupon is valid OR user clicked OK on expiration modal
            await proceedWithCheckout();
        });
    };

    const proceedWithCheckout = async () => {
        if (!cartId || !token) return;

        // ---- helpers ----
        const num = (v: any) => (isNaN(Number(v)) ? 0 : Number(v));
        const round2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100;

        // ⛳️ SPECIAL FEES → OrderSpecialFee[]
        const feeRows = feePayload?.specialfee ?? [];
        const normalizeFee = (f: any) => ({
            specialfee_id: String(f.specialfee_id ?? ""),
            specialfee_name: String(f.specialfee_name ?? ""),
            specialfee_amount: num(f.specialfee_amount),
            specialfee_tax_percentage: num(f.specialfee_tax_percentage),
            specialfee_tax_amount: num(f.specialfee_tax_amount),
            specialfee_taxable: f?.specialfee_taxable !== false,
        });

        // ⛳️ SHIPPING → ShippingOption[]
        // Wire these from your real shipping UI state:
        const shipping = (window as any)?.shippingPayload || {};
        const shipping_option = (() => {
            const amount = num(shipping.shipping_amount ?? shippingAmount);
            if (amount <= 0) return [];
            return [
                {
                    shipping_id: String(shipping.shipping_id ?? "S1"),
                    shipping_name: String(shipping.shipping_name ?? "Standard Delivery"),
                    shipping_amount: round2(amount),
                    shipping_tax_percentage: num(shipping.shipping_tax_percentage),
                    shipping_tax_amount: round2(num(shipping.shipping_tax_amount ?? shippingTaxAmount)),
                    shipping_taxable:
                        typeof shipping.shipping_taxable === "boolean"
                            ? shipping.shipping_taxable
                            : num(shipping.shipping_tax_amount ?? shippingTaxAmount) > 0,
                    shipping_delivery_date: String(shipping.shipping_delivery_date ?? ""),
                    shipping_delivery_time: String(shipping.shipping_delivery_time ?? ""),
                },
            ];
        })();

        // ⛳️ DISCOUNTS (top-level) - Get from CouponDiscount component state
        const appliedCodes = (couponDiscounts || []).map((d) => (d?.id || "").trim()).filter(Boolean);
        const discount_code = appliedCodes.join(",");
        const discount_amount = round2(
            Object.values(perItemCouponMap || {}).reduce((sum, v) => sum + num(v), 0)
        );

        // ⛳️ ITEMS → CartItem[]
        // ⛳️ ITEMS → CartItem[] (use UI-calculated values)
        const cart_items = (items || []).map((ci: any) => {
            const k = `${ci.product_id}:${ci.variant_id}`;
            const qty = Math.max(1, num(ci.quantity));

            // UI “original” unit (before discount) — prefer your effectiveMap when present
            // const unitBefore = num(effectiveMap[k] ?? ci.unit_retail_price);
            const unitBefore = num(ci.unit_retail_price);

            // rowMath gives us all the calculated values
            const { eachAfter, rowDisc, itemSub, itemAfterDiscount } = rowMath(ci);

            const changed_unit_price = round2(eachAfter);
            const item_sub_total = round2(itemAfterDiscount); // ✅ post-discount, pre-tax

            // split discount exactly like UI shows
            const discount_on_total_quantity = round2(rowDisc);
            const discount_on_unit_quantity = round2(rowDisc / qty);

            // keep prior tax block if present (we’re not altering tax here)
            const srvTaxInfo = ci.item_tax_info || {};
            const tax_percentage = num(srvTaxInfo.tax_percentage ?? ci.tax_details?.tax_rate ?? 0);
            const unit_tax_amount = round2(num(srvTaxInfo.unit_product_tax_amount ?? 0));
            const total_tax_amount = round2(num(srvTaxInfo.total_product_tax_amount ?? 0));

            const tax_details = {
                ...(ci.tax_details || {}),
                tax_rate: tax_percentage,
                tax_amount: total_tax_amount,
            };

            const loc = ci.storage_location || {};
            const storage_location = {
                warehouse_id: String(loc.warehouse_id ?? ""),
                warehouse_name: String(loc.warehouse_name ?? ""),
                zone_id: String(loc.zone_id ?? ""),
                zone_name: String(loc.zone_name ?? ""),
                rack_id: String(loc.rack_id ?? ""),
                rack_name: String(loc.rack_name ?? ""),
                bin_id: String(loc.bin_id ?? ""),
                bin_name: String(loc.bin_name ?? ""),
            };

            // for auditing: pre-discount line and total
            const total_price = round2(unitBefore * qty); // pre-discount, pre-tax
            const amount = total_price;

            return {
                product_id: String(ci.product_id),
                variant_id: String(ci.variant_id),
                storage_location,

                name: String(ci.name ?? ""),
                sku: ci.sku ? String(ci.sku) : undefined,

                unit_purchase_price: round2(num(ci.unit_purchase_price ?? unitBefore)),
                unit_retail_price: round2(unitBefore), // Uses effective_price from effectiveMap if available, otherwise unit_retail_price
                quantity: qty,

                // ✅ the UI numbers
                changed_unit_price,
                discount_on_unit_quantity,
                discount_on_total_quantity,
                item_sub_total,

                // keep tax block as-is (or override elsewhere if you hook TaxCloud in this page)
                tax_details,
                tax_amount: total_tax_amount,
                item_tax_info: {
                    tax_percentage,
                    unit_product_tax_amount: unit_tax_amount,
                    total_product_tax_amount: total_tax_amount,
                    tax_details,
                    taxable: Boolean(srvTaxInfo.taxable ?? (tax_percentage > 0)),
                },

                image_url: ci.image_url ? String(ci.image_url) : undefined,
                images: Array.isArray(ci.images) ? ci.images : undefined,
                tax_rule: ci.tax_rule || undefined,
                tax_group: ci.tax_group || undefined,

                total_price,
                amount,

                customizations: ci.customizations || undefined,
                package_dimensions: ci.package_dimensions || { length: 0, width: 0, height: 0, weight: 0 },

                is_production: ci.is_production !== false,
                design_id: ci.design_id ? String(ci.design_id) : undefined,
                design_name: ci.design_name ? String(ci.design_name) : undefined,
                preview_url: ci.preview_url ? String(ci.preview_url) : undefined,
            };
        });


        // ⛳️ Optional order tax summary (fill from your totals if you have them)
        const order_tax_summary = (() => {
            const taxableBase = cart_items.reduce((s, r) => s + num(r.item_sub_total || 0), 0);
            const totalTax = cart_items.reduce((s, r) => s + num(r.tax_amount || 0), 0)
                + shipping_option.reduce((s, r) => s + num(r.shipping_tax_amount || 0), 0)
                + (feeRows || []).reduce((s, f) => s + num(f.specialfee_tax_amount || 0), 0);

            // Blend rate (avoid div by zero)
            const blended = taxableBase > 0 ? (totalTax / taxableBase) * 100 : 0;

            return {
                tax_inclusive: false,
                overall_tax_amount: round2(totalTax),
                overall_tax_percentage: round2(blended),
                overall_taxable_base: round2(taxableBase),
                tax_status: "CALCULATED",
            };
        })();

        // ⛳️ Optional cart-level amounts if you already compute them in UI:
        const subtotal_amount = round2(
            cart_items.reduce((s, r) => s + num(r.item_sub_total || 0), 0)
        );
        const shipping_amount_top = round2(shipping_option.reduce((s, r) => s + num(r.shipping_amount || 0), 0));
        const fees_amount_top = round2(feeRows.reduce((s, f) => s + num(f.specialfee_amount || 0), 0));
        const tax_amount_top = round2(
            cart_items.reduce((s, r) => s + num(r.tax_amount || 0), 0) +
            shipping_option.reduce((s, r) => s + num(r.shipping_tax_amount || 0), 0) +
            feeRows.reduce((s, f) => s + num(f.specialfee_tax_amount || 0), 0)
        );
        const total_amount = round2(
            subtotal_amount +
            tax_amount_top +
            shipping_amount_top +
            fees_amount_top
        );

        // ---- FINAL BODY strictly matching your Go json tags ----
        const body = {
            discount_amount,
            discount_code,
            order_charges: {
                shipping_option,
                specialfee: feeRows.map(normalizeFee),
            },
            selected_fee_ids: feePayload?.selected_fee_ids ?? [],   // <- keep selected for re-open
            cart_items,
            order_tax_summary,
            subtotal_amount,
            total_amount,
            shipping_amount: shipping_amount_top,
            tax_amount: tax_amount_top,
        };


        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/carts/${cartId}`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                body: JSON.stringify(body),
            });
            if (!res.ok) {
                const t = await res.text();
                throw new Error(t || "Failed to update cart");
            }
            navigate(`/${base}/order/checkout`);
        } catch (e: any) {
            toast.error(e?.message || "Failed to proceed to checkout");
        }
    };



    // ---- simple image resolution (first/default image); pass imageUrlMap when available ----
    const resolvedImageFor = (it: CartItem, urlMap?: Record<string, string>) => {
        const previewRef = String(it.preview_url || "").trim();
        if (hasCustomDesign(it) && previewRef) {
            return getImageSrc(previewRef, urlMap || {}) || buildImageUrl(previewRef) || "";
        }
        const first =
            (it.images || []).find((img) => img.default) ||
            (it.images || [])[0] ||
            (it.image_url ? { url: it.image_url } : undefined);
        const id = idOf(first);
        return getImageSrc(id, urlMap || {}) || buildImageUrl(id) || "";
    };

    // ---- Keep per-item coupon allocation in sync when qty / unit changes ----
    const recomputeOrderLevelDiscounts = React.useCallback(() => {
        // If no coupons, clear split
        if (!couponDiscounts || couponDiscounts.length === 0) return;

        // Prefer a single order-level rule (percent or amount)
        const orderPercent = couponDiscounts.find(d => d.scope === "order" && d.type === "percent");
        const orderAmount = couponDiscounts.find(d => d.scope === "order" && d.type === "amount");

        // Build current bases using *effective* unit × quantity
        const bases = (items || []).map((ci) => {
            const k = keyFor(ci);
            const each = num(effectiveMap[k] ?? ci.unit_retail_price);
            const qty = num(ci.quantity || 0);
            const base = each * qty;
            return { k, base };
        });

        const next: Record<string, number> = {};

        if (orderPercent) {
            const pct = num(orderPercent.value);
            bases.forEach(({ k, base }) => {
                next[k] = round2((base * pct) / 100);
            });
        } else if (orderAmount) {
            const totalBase = bases.reduce((s, b) => s + b.base, 0);
            const pool = Math.min(num(orderAmount.value), totalBase);
            if (totalBase > 0 && pool > 0) {
                // Proportional split
                bases.forEach(({ k, base }) => {
                    next[k] = round2((base / totalBase) * pool);
                });
                // tiny rounding correction so sum(next) === pool
                const sum = Object.values(next).reduce((s, v) => s + v, 0);
                const diff = round2(pool - sum);
                if (Math.abs(diff) >= 0.01 && bases.length > 0) {
                    const lastK = bases[bases.length - 1].k;
                    next[lastK] = round2(num(next[lastK]) + diff);
                }
            } else {
                // nothing to allocate
                bases.forEach(({ k }) => (next[k] = 0));
            }
        } else {
            // Not an order-level discount (e.g., item-specific handled by CouponDiscount) → keep current map
            return;
        }

        setPerItemCouponMap(next);
    }, [couponDiscounts, items, effectiveMap]);

    React.useEffect(() => {
        recomputeOrderLevelDiscounts();
    }, [recomputeOrderLevelDiscounts]);

    const productImageIds = React.useMemo(() => {
        const out = new Set<string>();
        (items || []).forEach((it) => {
            const previewRef = String(it.preview_url || "").trim();
            if (hasCustomDesign(it) && previewRef) out.add(previewRef);
            const first =
                (it.images || []).find((img: any) => img?.default) ||
                (it.images || [])[0] ||
                (it.image_url ? { url: it.image_url } : undefined);
            const id = idOf(first);
            if (id) out.add(id);
            const fields = Array.isArray(it.customizations?.fields) ? it.customizations.fields : [];
            for (const f of fields) {
                if (String(f?.field_type || "").toLowerCase() !== "file") continue;
                const raw = f?.value as unknown;
                const fid =
                    typeof raw === "string"
                        ? raw.trim()
                        : raw && typeof raw === "object" && raw !== null && "url" in raw
                          ? String((raw as { url?: string }).url || "").trim()
                          : "";
                if (fid) out.add(fid);
            }
        });
        return Array.from(out);
    }, [items]);

    const dataForMap = React.useMemo(() => {
        if (!productImageIds.length) return [];
        return [{ product: { variants: [{ images: productImageIds.map((url) => ({ url })) }] } }];
    }, [productImageIds]);

    const imageUrlMap = useVariantImageUrlMap(dataForMap, token);

    // 🔧 bump when map content changes (even if the object ref is stable)
    const mapVersion = React.useMemo(
        () => (imageUrlMap ? Object.keys(imageUrlMap).length : 0),
        [imageUrlMap]
    );


    const resolvedImages = React.useMemo(
        () =>
            (productImages || []).map((img: any) => {
                const id = idOf(img);
                return {
                    src: getImageSrc(id, imageUrlMap) || buildImageUrl(id),
                    alt: img?.alt_text || "",
                };
            }),
        [productImages, mapVersion]   // <-- changed here
    );

    useEffect(() => {
        (items || []).forEach((it) => {
            const k = `${it.product_id}:${it.variant_id}`;
            // ✅ only fetch if we have not hydrated/seeded a value
            if (effectiveMap[k] === undefined || effectiveMap[k] === null) {
                fetchEffectivePrice(it, Number(it.quantity || 1));
            }
        });
    }, [items, fetchEffectivePrice, effectiveMap]);

    const initialFeeIds = useMemo<string[] | undefined>(() => {
        const rows = cartData?.order_charges?.specialfee ?? [];
        const ids = Array.isArray(rows)
            ? rows.map((r: any) => String(r?.specialfee_id)).filter(Boolean)
            : [];
        return ids.length ? ids : undefined;
    }, [cartData]);


    // ---- UI ----
    const suppliersHref = `/${base}/suppliers`;

    return (
        <div className="active">
            {/* <div className="cart-page-header">
                <div className="cart-page-header-content">
                    <Link to={suppliersHref} className="cart-back-link">
                        <span>←</span> Continue Shopping
                    </Link>
                    <div className="cart-header-right" />
                </div>
            </div> */}

            <div className="cart-page-content">
                <div className="cart-page-title">
                    <span className="cart-page-title-icon">🛒</span>
                    Shopping Cart
                </div>
                <div className="cart-item-count">
                    {items.length} {items.length === 1 ? "item" : "items"} in your cart
                </div>

                <div className="cart-layout">
                    <div className="cart-items-section">
                        {!loading && !items.length ? (
                            <div className="empty-cart">
                                <div className="empty-cart-icon">🛒</div>
                                <div className="empty-cart-title">Your cart is empty</div>
                                <div className="empty-cart-text">Add items from the catalog to get started.</div>
                                <Link to={suppliersHref} className="btn-start-shopping">
                                    Shop Now
                                </Link>
                            </div>
                        ) : (
                        <table className="order-cart-table">
                            <colgroup>
                                <col className="order-cart-col-product" />
                                <col className="order-cart-col-price" />
                                <col className="order-cart-col-qty" />
                                <col className="order-cart-col-discount" />
                                <col className="order-cart-col-subtotal" />
                                <col className="order-cart-col-action" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Price</th>
                                    <th>Quantity</th>
                                    <th>Discount</th>
                                    <th>Subtotal</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                        {loading ? (
                            <tr>
                                <td>
                                    <div className="cart-item-info">
                                        <div className="cart-item-image">
                                            <img src={imagecustomRounded} alt="" style={{ width: 56, height: 56, objectFit: "contain", borderRadius: 8, opacity: 0.5, border: "none" }} />
                                        </div>
                                        <div className="cart-item-details">
                                            <h4>Loading...</h4>
                                            <div className="cart-item-meta">—</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="text-center">—</td>
                                <td className="text-center">—</td>
                                <td className="text-center">—</td>
                                <td className="text-center">—</td>
                                <td className="text-center">—</td>
                            </tr>
                        ) : items.map((it) => {
                            const rm = rowMath(it);
                            const key = `${it.product_id}:${it.variant_id}`;
                            const imgSrc = resolvedImageFor(it, imageUrlMap);
                            const unitRetail = num(it.unit_retail_price);
                            const changedPrice = num(effectiveMap[key] ?? it.changed_unit_price) || unitRetail;
                            const useLiveCoupon = couponDiscounts.length > 0 && typeof perItemCouponMap[key] === "number";
                            const { lineDiscount } = getAgentRealtorCheckoutLinePricing({
                                item: it,
                                qty: rm.qty,
                                unitRetail,
                                changedUnitPrice: useLiveCoupon ? rm.eachAfter : changedPrice,
                                perItemCouponMap,
                                lineKey: key,
                                useLiveCoupon,
                            });

                            return (
                                <tr key={key}>
                                    <td>
                                    <div className="cart-item-info">
                                        <div className="cart-item-image">
                                            <img
                                                src={imgSrc || imagecustomRounded}
                                                alt={it.name}
                                                style={{ width: 56, height: 56, objectFit: "contain", borderRadius: 8, border: "none" }}
                                                onError={(e) => {
                                                    (e.currentTarget as HTMLImageElement).src = imagecustomRounded;
                                                }}
                                            />
                                        </div>
                                        <div className="cart-item-details">
                                            <h4 className="wrap-anywhere">{it.name}</h4>
                                            <div className="cart-item-meta wrap-anywhere">
                                                {(() => {
                                                    const fields = Array.isArray(it.customizations?.fields) ? it.customizations.fields : [];
                                                    if (!fields.length) return null;
                                                    const isFile = (f: any) => String(f?.field_type || "").toLowerCase() === "file";
                                                    const firstFileVal = (raw: any): string => {
                                                        if (!raw) return "";
                                                        if (typeof raw === "string") return raw.trim();
                                                        if (raw && typeof raw === "object" && raw.url) return String(raw.url).trim();
                                                        return "";
                                                    };
                                                    const hasValue = (f: any): boolean => {
                                                        if (isFile(f)) return !!firstFileVal(f?.value);
                                                        return String(f?.value ?? "").trim().length > 0;
                                                    };
                                                    if (!fields.some(hasValue)) return null;
                                                    const textFields = fields.filter((f: any) => !isFile(f) && hasValue(f));
                                                    const fileFields = fields.filter((f: any) => isFile(f) && hasValue(f));
                                                    return (
                                                        <div className="custom-fields-container mt-1">
                                                            {textFields.map((field: any, idx: number) => (
                                                                <div key={`cf-t-${field?._id || field?.field_name || idx}`} className="mb-1" style={{ wordBreak: "break-word", maxWidth: 420 }}>
                                                                    <strong>{field.field_name}:</strong>{" "}
                                                                    <span>{String(field?.value ?? "").trim()}</span>
                                                                </div>
                                                            ))}
                                                            {fileFields.map((field: any, idx: number) => {
                                                                const fid = firstFileVal(field?.value);
                                                                const href =
                                                                    (fid && imageUrlMap[fid]) ||
                                                                    getImageSrc(fid, imageUrlMap) ||
                                                                    buildImageUrl(fid) ||
                                                                    "";
                                                                return (
                                                                    <div key={`cf-f-${field?._id || field?.field_name || idx}`} className="mb-1" style={{ wordBreak: "break-word", maxWidth: 420 }}>
                                                                        <div className="text-muted small">{field.field_name}</div>
                                                                        {href ? (
                                                                            <a href={href} target="_blank" rel="noopener noreferrer">
                                                                                <img
                                                                                    src={href}
                                                                                    alt={String(field.field_name || "Customization")}
                                                                                    style={{
                                                                                        maxWidth: 100,
                                                                                        height: "auto",
                                                                                        cursor: "pointer",
                                                                                        borderRadius: 8,
                                                                                        display: "block",
                                                                                        // border: "1px solid #e5e7eb",
                                                                                    }}
                                                                                    onError={(e) => {
                                                                                        (e.currentTarget as HTMLImageElement).src = imagecustomRounded;
                                                                                    }}
                                                                                />
                                                                            </a>
                                                                        ) : /^[0-9a-f]{24}$/i.test(fid) ? (
                                                                            <span className="text-muted small">Loading…</span>
                                                                        ) : null}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                    </td>
                                    <td className="cart-item-price">${money(unitRetail)}</td>
                                    <td>
                                    <div className="cart-quantity">
                                        <button type="button" className="cart-qty-btn" onClick={() => updateQuantity(it, Math.max(1, (it.quantity || 1) - 1))} aria-label="Decrease">−</button>
                                        <input type="number" className="cart-qty-input" min={1} value={it.quantity} onChange={(e) => updateQuantity(it, Math.max(1, parseInt(e.target.value || "1", 10)))} />
                                        <button type="button" className="cart-qty-btn" onClick={() => updateQuantity(it, (it.quantity || 1) + 1)} aria-label="Increase">+</button>
                                    </div>
                                    </td>
                                    <td className="cart-item-discount">
                                        <DiscountAmountDisplay amount={lineDiscount} />
                                    </td>
                                    <td className="cart-item-subtotal">${money(rm.itemSub)}</td>
                                    <td className="cart-item-action">
                                        <button type="button" className="cart-item-remove" onClick={() => removeItem(it.product_id, it.variant_id)} disabled={removingKey === key} aria-label="Remove">
                                            {removingKey === key ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> : <i className="ri-close-circle-line cart-item-remove-icon" aria-hidden="true" />}
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                            </tbody>
                        </table>
                        )}
                    </div>

                    <div className="order-summary">
                        <div className="order-summary-title">
                            <span>💳</span> Order Summary
                        </div>
                        <div className="order-summary-rows">
                            <div className={`order-summary-row ${removingKey || items.length === 0 ? "tbd" : ""}`}>
                                <span className="label">Sub Total:</span>
                                <span className="value">{showTBD(subTotalProducts)}</span>
                            </div>

                            {/* {base === "agent" && items.length > 0 && (
                                removingKey ? (
                                    <div className="order-summary-row discount tbd">
                                        <span className="label">Discount (coupon):</span>
                                        <span className="value">TBD</span>
                                    </div>
                                ) : couponAmount > 0 && couponDiscounts.length > 0 ? (
                                    <div className="order-summary-row discount">
                                        <span className="label">Discount ({couponDiscounts[0]?.id || "coupon"}):</span>
                                        <span className="value">-${money(couponAmount)}</span>
                                    </div>
                                ) : (
                                    <div className="order-summary-row discount">
                                        <span className="label">Discount (coupon):</span>
                                        <span className="value">-$0.00</span>
                                    </div>
                                )
                            )} */}

                            <div className={`order-summary-row ${removingKey || items.length === 0 ? "tbd" : ""}`}>
                                <span className="label">Shipping Charge:</span>
                                <span className="value">{showTBD(shippingAmount)}</span>
                            </div>

                            {base === "agent" && items.length > 0 && (
                                <div className={`order-summary-row ${removingKey ? "tbd" : ""}`}>
                                    <span className="label">Special Fee:</span>
                                    <span className="value">TBD</span>

                                    {/* <span className="value">{showTBD(specialFeeAmount)}</span> */}
                                </div>
                            )}

                            <div className={`order-summary-row ${removingKey || items.length === 0 ? "tbd" : ""}`}>
                                <span className="label">Tax:</span>
                                <span className="value">{showTBD(totalTaxAll)}</span>
                            </div>
                        </div>

                        <div className={`order-summary-total ${removingKey || items.length === 0 ? "tbd" : ""}`}>
                            <span className="label">Total (USD):</span>
                            <span className="value">{showTBD(grandTotal)}</span>
                        </div>

                            {/* Collapsible Apply Code (optional lightweight UX) */}
                            {/* {!showCoupon ? (
                                <button
                                    type="button"
                                    className="align-items-center br-8 btn btn-cancel d-flex fw-medium justify-content-center mb-3 w-100"
                                    onClick={() => setShowCoupon(true)}
                                >
                                    <i className="ri-price-tag-3-line me-2"></i> Apply Discount Code
                                </button>
                            ) : (
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        // If you still want to allow manual code entry to feed CouponDiscount
                                        // you can store couponInput then trigger a refresh call; otherwise, the component handles it.
                                        setShowCoupon(false);
                                    }}
                                    className="mb-3"
                                >
                                    <div className="d-flex gap-2 justify-content-center">
                                        <div className="input-group w-75">
                                            <input
                                                className="form-control"
                                                placeholder="Enter discount code"
                                                value={couponInput}
                                                onChange={(e) => setCouponInput(e.target.value)}
                                            />
                                        </div>
                                        <button className="btn btn-primary" disabled={applying}>
                                            Apply
                                        </button>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn btn-ghost-dark btn-link mt-2 w-100"
                                        onClick={() => {
                                            setShowCoupon(false);
                                            setCouponInput("");
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </form>
                            )} */}

                            {/* The actual CouponDiscount engine that validates/applies codes and allocates per item */}
                            {/* {base === "agent" && !removingKey && items.length > 0 && (
                                <BrokerageAndAgentCouponDiscount
                                    token={token!}
                                    supplierId={supplierId || ""}
                                    createdById={userId || ""}
                                    items={couponItems}
                                    eligibilityTotal={eligibilityTotal}
                                    onDiscountsChange={(ds) => setCouponDiscounts(ds)}
                                    onPerItemDiscountMap={(map) => {
                                        setPerItemCouponMap(map || {});   // initial seed
                                        // Our effect will refresh this allocation on qty/price change
                                    }}
                                    initialDiscountCode={cartData?.discount_code}      // ✅ Pass saved coupon code
                                    initialDiscountAmount={cartData?.discount_amount}  // ✅ Pass saved discount amount for immediate display
                                    className="mb-2"
                                />
                            )} */}


                            {/* Special Fee Picker */}
                            {/* {base === "agent" && !removingKey && items.length > 0 && (
                                <div className="">
                                    <SpecialFeePicker
                                        ref={feeRef}
                                        token={token || ""}
                                        personId={userId || ""}
                                        shippingAddress={null}
                                        supplierId={supplierId || ""}
                                        knownTaxType="manual"
                                        isTaxable
                                        statusOk
                                        initialSelectedIds={initialFeeIds}
                                        onPayloadChange={handleFeePayloadChange}
                                    />
                                    <div className="d-flex justify-content-between mt-2 text-muted small">
                                        <span>Selected Fees:</span>
                                        <span>
                                            ${Number(feePayload?.total_amount || 0).toFixed(2)}
                                            {Number(feePayload?.total_tax_amount || 0) > 0 && (
                                                <> (+${Number(feePayload?.total_tax_amount || 0).toFixed(2)} tax)</>
                                            )}
                                        </span>
                                    </div>
                                </div>
                            )} */}

                            <div className="order-summary-actions">
                                <Link
                                    to={`${baseRoute}/suppliers`}
                                    className="btn-continue-shopping-cart"
                                    style={{ display: "block", textAlign: "center", textDecoration: "none" }}
                                >
                                    Continue Shopping
                                </Link>
                                <button
                                    type="button"
                                    className="btn-checkout"
                                    onClick={onProceedToCheckout}
                                    disabled={checkingCoupon}
                                >
                                    {checkingCoupon ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                                            Validating...
                                        </>
                                    ) : (
                                        <>
                                            <i className="ri-bank-card-line me-2" /> Checkout
                                        </>
                                    )}
                                </button>
                            </div>

                            <div className="secure-checkout-text">Secure checkout with SSL encryption</div>
                        </div>
                    </div>
                </div>

            {/* Coupon Expiration Modal */}
            {CouponExpirationModal}
        </div>
    );
};

export default OrderCartPage;
